import React from 'react';

import {
  LandingSelectedEntities,
} from '../../../components';

const LandingSelectedArticles = ({ id, entity }) => {

  return (
    <LandingSelectedEntities
      id={id}
      type="articles"
      link={entity.getIn(['field_link', 0, 'alias'], '/nl/artikelen')}
      entities={entity.getIn(['field_landing_selected_articles'])}
      title={entity.getIn(['field_title', 0, 'value'])}
    />
  );
};

export default LandingSelectedArticles;
